import { resizeBitmap } from "./resize.ts";
import type { Bitmap } from "./types.ts";

function scaleBitmap(image: Bitmap, scale: number) {
	const targetWidth = Math.round(image.width * scale);
	const targetHeight = Math.round(image.height * scale);
	return resizeBitmap(image, targetWidth, targetHeight);
}

export default scaleBitmap;
